import 'consumerweb-shim';
import React from 'react';
import { connect } from 'react-redux';
import * as ViewActions from '../actions/Actions';
import Charity from '../../charity';
import * as analytics from '../../../lib/analytics';

import content from '../../../lib/i18n';
const i18n = content('hub/components/featuredDesktopContainer');

export class CharityContainer extends React.Component {
  componentDidMount() {}

  handleCharityClick = (selectedIndex, source, npid) => {
    this.props.dispatch(ViewActions.selectedCharity(selectedIndex, source));

    analytics.trackLinkWithData(
      'charity',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  handleInfoClick = (selectedIndexCharityInfo, source, npid) => {
    // this.props.dispatch(
    //   ViewActions.selectedCharityInfo(selectedIndexCharityInfo, source)
    // );

    analytics.trackLinkWithData(
      'infoIcon',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  handleDefaultCharityState = source => {
    this.props.dispatch(ViewActions.defaultState(source));
  };

  handlePopOverClose = source => {
    this.props.dispatch(ViewActions.defaultPopoverState(source));
  };

  handleSeeMore = source => {
    this.props.dispatch(ViewActions.expandSeeMore(source));
  };

  render() {
    const npoBaseUrl = `${this.props.coBrand}charity/`;
    return (
      <div>
        <Charity
          onHandleClick={this.handleCharityClick}
          onInfoClick={this.handleInfoClick}
          onPopoverClose={this.handlePopOverClose}
          onHandleDefaultCharityState={this.handleDefaultCharityState}
          handleSeeMore={this.handleSeeMore}
          charityModuleTitle={i18n('title.charityModule')}
          charityModuleSubHeader={i18n('title.charityModuleSubheader')}
          charityModuleChooseAmountText={i18n(
            'title.charityModuleChooseAmount'
          )}
          checkoutErrorMsg={i18n('label.error-msg')}
          campaignState='ACTIVE'
          npoBaseUrl={npoBaseUrl}
          source='featured'
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(state => ({
  // connects reducer with component
  csrf: state.server.csrf,
  coBrand: state.server.coBrand,
  selectedCharity: state.charity.featured.selectedCharity,
  selectedIndex: state.charity.featured.selectedIndex,
  seeMoreClicked: state.charity.featured.seeMoreClicked,
  selectedIndexCharityInfo: state.charity.featured.selectedIndexCharityInfo,
  clickedRadioBtn: state.charity.featured.clickedRadioBtn,
  charities: state.server.data.featured,
  donationInfo: state.server.donationInfo,
  amounts: state.server.data.amounts,
}))(CharityContainer);
